import React, { useEffect, useRef, useState } from "react";

const AreaMap = ({ data }) => {
  const mapRef = useRef(null);
  const [locationName, setLocationName] = useState(null);
  const [location, setLocation] = useState(null);

  const reverseGeocode = async (lat, lng) => {
    try {
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyDX4aBvjREAhJu5058mjl7xYJMHrGJTeqE&libraries=places`
      );
      const json = await res.json();
      if (json.status === "OK") {
        const result = json.results[0];
        const cityComponent = result.address_components.find((comp) =>
          comp.types.includes("locality")
        );
        const areaComponent = result.address_components.find(
          (comp) =>
            comp.types.includes("sublocality") ||
            comp.types.includes("neighborhood")
        );
        const city = cityComponent?.long_name || "";
        const area = areaComponent?.long_name || "";
        setLocationName(`${area ? area + ", " : ""}${city}`);
      } else {
        console.error("Geocoding failed:", json.status);
        setLocationName("Unknown location");
      }
    } catch (err) {
      console.error("Reverse geocode error:", err);
      setLocationName("Unknown location");
    }
  };

  useEffect(() => {
    const lat = data?.location?.lat;
    const lng = data?.location?.lng;

    if (lat && lng) {
      setLocation({ lat, lng });
      reverseGeocode(lat, lng);
    }
  }, [data]);

  useEffect(() => {
    if (!location) return;

    const loadMap = () => {
      const map = new window.google.maps.Map(mapRef.current, {
        center: location,
        zoom: 15,
        disableDefaultUI: true,
      });

      new window.google.maps.Circle({
        strokeColor: "#e6e600",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#e6e600",
        fillOpacity: 0.35,
        map,
        center: location,
        radius: 900,
      });
    };

    if (!window.google) {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&callback=initMap`;
      script.async = true;
      window.initMap = loadMap;
      document.head.appendChild(script);
    } else {
      loadMap();
    }
  }, [location]);

  return (
    <div>
      <div style={{ marginBottom: "1rem" }}>
        {locationName && (
          <div style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
            📍 Location: {locationName}
          </div>
        )}
        <div
          ref={mapRef}
          style={{
            height: "440px",
            width: "100%",
            borderRadius: "12px",
            overflow: "hidden",
          }}
        />
      </div>
    </div>
  );
};

export default AreaMap;
